import type { CluePublic } from '@cloudfruit-hunts/shared';

interface CipherClueProps {
  clue: CluePublic;
}

export function CipherClue({ clue }: CipherClueProps) {
  const cipherConfig = clue.interactivityConfig.cipher;

  return (
    <div className="py-4">
      <p className="text-lg text-text-dark leading-relaxed mb-4">
        {clue.contentText}
      </p>

      {cipherConfig && (
        <div className="bg-gray-900 text-green-400 font-mono p-4 rounded-lg text-center text-xl tracking-wider">
          {cipherConfig.encodedText}
        </div>
      )}

      {cipherConfig?.keyHint && (
        <p className="mt-3 text-sm text-text-light italic">
          Key hint: {cipherConfig.keyHint}
        </p>
      )}
    </div>
  );
}
